import { createSlice } from '@reduxjs/toolkit';
import { core2025Theme } from '../constant/ThemeConstant';

export const themeReducer = createSlice({
    name: "themeSlice",
    initialState: {
        backgroundColor: core2025Theme.backgroundColor,
        textColor: core2025Theme.textColor,
        primary: core2025Theme.primary,
        secondary: core2025Theme.secondary
    },
    reducers: {
        applyTheme: (state, action) => {
            state.backgroundColor = action.payload.backgroundColor;
            state.textColor = action.payload.textColor;
            state.primary = action.payload.primary;
            state.secondary = action.payload.secondary;
        }
    }
});

export const { applyTheme } = themeReducer.actions;

export default themeReducer.reducer;